/**
 * BOTTOM GENERAL INITS
 */



/**
 * ---------------------------------------------------------------
 * bottom straight Init Stuff
 * ---------------------------------------------------------------
 */

// Init and setup alertas advice message pannel
app.alerts.init();


/* EOF */